export default __webpack_public_path__ + "static/media/message.ce1601b0.svg";